<template>
  <div class="purchase">

    <div class="myheaderbar">
      <h1>Purchases</h1>
    </div>
    
    <br>
    <div  style="margin: 1em;">
      <b-field>
        <h1>Purchases of  <b>{{selectedContact.firsname}} {{selectedContact.name}}</b></h1>
      </b-field>

      <div style="height: 2em"></div>
      
      <!-- TODO HERE -->
      <!-- <ListPanelFilterPurchase/> -->

      <!-- {{allPurchases}} -->

      <!-- {{getProfile}} -->
      


<!-- :bordered="isBordered"
  :striped="isStriped"
  :narrowed="isNarrowed"
  :hoverable="isHoverable"
  :loading="isLoading"
  :focusable="isFocusable"
  :mobile-cards="hasMobileCards" -->

        <b-table
            :data="allPurchases"
            :mobile-cards=true
            :focusable=true
            detailed
            detail-key="id"
            :show-detail-icon="showDetailIcon"
            paginated
            per-page="25"
            >
            <template slot-scope="props">
                <!-- <b-table-column field="id" label="ID" width="40" numeric>
                    {{ props.row.id }}
                </b-table-column> -->

                <b-table-column field="id" label="ID">
                    <template v-if="showDetailIcon">
                        {{ props.row.id }}
                    </template>
                    <template v-else>
                        <a @click="toggle(props.row)">
                            {{ props.row.id }}
                        </a>
                    </template>
                </b-table-column>

                <b-table-column field="amount" label="Amount" sortable>
                    {{ props.row.amount }} €
                </b-table-column>

                <b-table-column field="item" label="Product/Service" sortable>
                    {{ props.row.item | truncate(20) }}
                </b-table-column>

                <!-- <b-table-column field="comment" label="Comment" width="300">
                    {{ props.row.comment | truncate(35) }}
                </b-table-column> -->

                <b-table-column field="date" label="Date" centered>
                    <span class="tag is-success">
                        {{ new Date(props.row.pdate).toLocaleDateString() }}
                    </span>
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
                <article class="media">
                    <!-- <figure class="media-left">
                        <p class="image is-64x64">
                            <img src="/static/img/placeholder-128x128.png">
                        </p>
                    </figure> -->
                    <div class="media-content">
                        <div class="content">
                            <p>
                                <strong>{{ props.row.item }} </strong>
                                <br>
                                
                                <strong>{{ props.row.comment }}</strong>
                                <br>
                                <strong>Amount: {{ props.row.amount }} €</strong>
                                <!-- <small>31m</small> -->
                                <br>
                                ContactID: {{props.row.contactid}}
                                <br>
                                UserID: {{props.row.userid}} | {{props.row.userdisplayname}}
                                <br>
                                AccountID: {{props.row.accountid}}
                            </p>
                        </div>
                    </div>
                </article>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>






    </div>
    <b-button @click="$router.back(-1)"
      icon-left="fas fa-search"
      type="is-primary">
      BACK
    </b-button>

  </div>
</template>

<script>
  // import ListPanelFilterPurchase from '@/components/main/purchase/ListPanelFilter.vue';
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
    name: 'PurchaseView',
    components: {
      // ListPanelFilterPurchase
    },
    data() {
        return {
            // data,
            // defaultOpenedDetails: [1],
            showDetailIcon: true
        }
    },
    created () {
      this.fetchPurchases(this.selectedContact) 
    },
    filters: {
      /**
      * Filter to truncate string, accepts a length parameter
      */
      truncate(value, length) {
          return value.length > length
              ? value.substr(0, length) + '...'
              : value
      }
    },
    computed: {
      ...mapGetters(['allPurchases', 'selectedPurchase', 'selectedContact', 'allContacts']), // , 'getProfile'
    },
    methods: {
      ...mapActions(['fetchPurchases', 'putSelectedPurchase']),
      toggle(row) {
          this.$refs.table.toggleDetails(row)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
</style>